import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NwMenuComponent } from './nw-menu.component';

const routes: Routes = [{
    path: 'nw-menu',
    component: NwMenuComponent
}];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class NwMenuRoutingModule { }
